import { checkObjectValueUnique } from '@libs';

/**
 * 整个 App 的路由配置
 */

// 无论 ERouter 定义为 enum 还是 object， key 值重复 依赖 compiler 检测（tslint 4.0开始  已去除 no-duplicate-key rule）
export var ERouter = /*#__PURE__*/function (ERouter) {
  ERouter["ROOT"] = "/";
  ERouter["TEST_MGR_ROOT"] = "/web/test-mgr";
  ERouter["TEST_MGR_TEST_DESIGN"] = "/web/test-mgr/testdesign";
  ERouter["TEST_MGR_CASE_TEMPLATE"] = "/web/test-mgr/caseTemplate";
  ERouter["TEST_MGR_CASE_MGR"] = "/web/test-mgr/caseMgr";
  ERouter["TEST_MGR_TEST_PLAN"] = "/web/test-mgr/testplan";
  ERouter["TEST_MGR_TEST_REPORT"] = "/web/test-mgr/testReport";
  ERouter["TEST_MGR_TEST_REPORT_ADD"] = "/web/test-mgr/testReport/add";
  ERouter["TEST_MGR_TEST_REPORT_DETAIL"] = "/web/test-mgr/testReport/detail";
  ERouter["TEST_MGR_TEST_PLAN_ADD"] = "/web/test-mgr/testplan/add";
  ERouter["TEST_MGR_TEST_TEAM_SET"] = "/web/test-mgr/teamset";
  ERouter["TEST_MGR_TEST_TEAM_SET_TEST_PLAN_SETTING"] = "/web/test-mgr/teamset/testPlan/setting";
  ERouter["TEST_MGR_TEST_TEAM_SET_PERM_APPLY"] = "/web/test-mgr/teamset/permission/apply";
  ERouter["TEST_MGR_TEST_TEAM_SET_REPORT_SETTING"] = "/web/test-mgr/teamset/report/setting";
  ERouter["TEST_MGR_TEAM_SET_TAGS_MGR"] = "/web/test-mgr/teamset/tagsmgr";
  ERouter["TEST_MGR_TEAM_STATISTICS"] = "/web/test-mgr/teamStatistics";
  ERouter["TEST_MGR_TEAM_STATISTICS_DETAIL_LIST"] = "/web/test-mgr/teamStatistics/detailList";
  ERouter["TEST_MGR_TEAM_STATISTICS_PLAN_DETAIL"] = "/web/test-mgr/teamStatistics/planDetail";
  ERouter["TEST_MGR_UNION_PLAN"] = "/web/test-mgr/unionPlan";
  ERouter["TEST_MGR_HELP_DOC"] = "/test-mgr/helpDoc";
  ERouter["TEST_MGR_PERMISSION_APPLY"] = "/web/test-mgr/permission/apply";
  ERouter["HOME_PAGE"] = "/web/test-mgr/homepage";
  ERouter["KTEST_WORKBENCH"] = "/workbench";
  ERouter["MARKDOWN"] = "/web/test-mgr/markdown";
  ERouter["TEST_MGR_MIND"] = "/web/test-mgr/mind";
  ERouter["TEST_MGR_AI_MIND"] = "/web/test-mgr/AImind";
  ERouter["TEST_MGR_LOCAL_MIND"] = "/web/test-mgr/localMind";
  ERouter["PRECTEST_TASK"] = "/web/test-mgr/prectest/task";
  ERouter["PRECTEST_TASK_DETAIL"] = "/web/test-mgr/prectest/task/detail";
  ERouter["TEST_MGR_AI_PLAN"] = "/web/test-mgr/aiplan";
  ERouter["TEST_MGR_AI_PLAN_ADD"] = "/web/test-mgr/aiplan/add";
  ERouter["TEST_MGR_AI_PLAN_EXECUTE"] = "/web/test-mgr/aiplan/execute";
  ERouter["PERSONAL_WORK_BENCH_PERSONAL_VIEW"] = "/web/workbench/personalView";
  ERouter["USER_CENTER_MY_APPLICATION"] = "/web/userCenter";
  ERouter["KTEST_KCASE_DOCUMENT_PREPROCESSING"] = "/web/test-mgr/documentPreprocessing";
  ERouter["KTEST_KCASE_AI_GENERATE_CASE"] = "/web/test-mgr/aiGenerateCase";
  ERouter["KTEST_KCASE_AI_CONFIG"] = "/web/test-mgr/aiConfig";
  ERouter["KTEST_KCASE_IFRAME_AI_GENERATE_CASE"] = "/web/test-mgr/iframeAIGenerateCase";
  return ERouter;
}({});
checkObjectValueUnique(ERouter, 'ERouter');